export type UserProfileRequest = {
    type: string;
    attributes: {
        properties: Record<string, string>;
        email: string;
    },
    meta: {
        patch_properties: {
            append: Record<string, string>;
            unappend: Record<string, string>;
        }
    }
};

export type UserMarketingRequestAttributes = {
    email?: string;
    phone_number?: string;
    subscriptions: {
        email?: {
            marketing: { consent: string; };
        };
        sms?: {
            marketing: { consent: string; };
            transactional: { consent: string; };
        }
    };
};

export type UserMarketingRequest = {
    type: string;
    attributes: {
        profile: {
            data: {
                type: string;
                attributes: UserMarketingRequestAttributes;
            }
        }
    },
    relationships: {
        list: {
            data: {
                type: string;
                id: string;
            }
        }
    }
};

export const updateUserProfileService = (payload: UserProfileRequest) => {
    return fetch("https://a.klaviyo.com/client/profiles?company_id=VQw3Yi", {
        method: "POST",
        headers: {
            accept: "application/vnd.api+json",
            revision: "2025-01-15",
            "content-type": "application/vnd.api+json"
        },
        body: JSON.stringify({ data: payload }),
    });
};

export const subscribeUserMarketingService = (payload: UserMarketingRequest) => {
    return fetch("https://a.klaviyo.com/client/subscriptions?company_id=VQw3Yi", {
        method: "POST",
        headers: {
            accept: "application/vnd.api+json",
            revision: "2025-01-15",
            "content-type": "application/vnd.api+json"
        },
        body: JSON.stringify({ data: payload }),
    });
};